import React from 'react';
import { View, TouchableOpacity, Image, StyleSheet } from 'react-native';

interface ITouchableImageProps{
    onPress:()=>void;
    source:string | any;
    imageStyles?:any;
    style?:any;
}

export const TouchableImage=(props:ITouchableImageProps)=>{

    const { onPress, source, imageStyles, style } = props;

    const newImageStyles = !!imageStyles ? (Array.isArray(imageStyles) ? imageStyles : [imageStyles]) : [];
    const newContainerStyles = !!styles ? (Array.isArray(styles) ? styles : [styles]) : [];

    return (
        <TouchableOpacity onPress={onPress} style={[styles.container,...newContainerStyles]}>
            <Image source={source} style={[styles.image,...newImageStyles]}/>
        </TouchableOpacity>
    )
}


const styles = StyleSheet.create({
    container:{
        width:14,
        height:14,
        justifyContent:"center",
        alignItems:"center"
    },
    image:{
        width:10,
        height:10,
    }
})